// src/components/Explore/AvailabilityBadge.jsx
// Shows program availability status (spots left, waitlist, closed)

import React from 'react';
import { AVAILABILITY_STATUS } from '../../constants/exploreFilters';
import styles from './AvailabilityBadge.module.css';

const AvailabilityBadge = ({ status, spotsLeft }) => {
  const getContent = () => {
    switch (status) {
      case AVAILABILITY_STATUS.AVAILABLE:
        return {
          className: styles.available,
          text: spotsLeft ? `${spotsLeft} spots` : 'Available'
        };
      case AVAILABILITY_STATUS.LIMITED:
        return {
          className: styles.limited,
          text: `${spotsLeft} spot${spotsLeft !== 1 ? 's' : ''} left`
        };
      case AVAILABILITY_STATUS.WAITLIST:
        return {
          className: styles.waitlist,
          text: 'Waitlist'
        };
      case AVAILABILITY_STATUS.CLOSED:
        return {
          className: styles.closed,
          text: 'Closed'
        };
      default:
        return {
          className: styles.available,
          text: 'Open'
        };
    }
  };

  const { className, text } = getContent();

  return (
    <span className={`${styles.badge} ${className}`}>
      <span className={styles.dot} />
      {text}
    </span>
  );
};

export default AvailabilityBadge;










